<template>
  <div>
    <h3>{{ title }}</h3>

    <DashbordsCalendar @change="$emit('change', $event)">
      <template v-if="$scopedSlots.filters" #filters>
        <slot name="filters" />
      </template>
      <template #summary="slotProps">
        <slot name="summary" v-bind="slotProps" />
      </template>
    </DashbordsCalendar>

    <slot :is-loading="isLoading" />
  </div>
</template>

<script>
import DashbordsCalendar from '@/views/Components/Elements/DashbordsCalendar.vue'

export default {
  components: {
    DashbordsCalendar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
